import { useSelector } from 'react-redux';

export const MakeFields = () => {
  const { rut } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      textArea: '',
      disabled: true,
      required: true,
      value: rut,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      textArea: '',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      inputAdornment: '',
      label: 'Escribir comentario',
      textArea: '4',
      disabled: false,
      required: false,
      rows: 4,
      multiline: true,
    },
  ];
};
